import React from 'react'
import { useTheme } from '../../hooks/useTheme'

const Footer: React.FC = () => {
  const { colors } = useTheme()
  const youtubeIcon = (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  )

  const instagramIcon = (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm4.441 7.313c.057.86.057 2.004.057 3.687v2a5.733 5.733 0 0 1-.114 1.002c-.15.56-.587 1.01-1.146 1.16-.288.075-.644.114-1.002.114H9.764c-.358 0-.714-.039-1.002-.114-.559-.15-.996-.6-1.146-1.16a5.733 5.733 0 0 1-.114-1.002v-2c0-1.683 0-2.827.057-3.687.15-.56.587-1.01 1.146-1.16.288-.075.644-.114 1.002-.114h4.472c.358 0 .714.039 1.002.114.559.15.996.6 1.146 1.16zM12 7.778c-1.17 0-2.222 1.052-2.222 2.222S10.83 12.222 12 12.222s2.222-1.052 2.222-2.222-1.052-2.222-2.222-2.222zm3.333 0a.556.556 0 1 1 0 1.111.556.556 0 0 1 0-1.111z" />
    </svg>
  )

  const facebookIcon = (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  )

  return (
    <footer
      style={{
        background: `linear-gradient(to bottom, ${colors.surface}, ${colors.primary}4D)`,
        borderTopColor: colors.border,
      }}
      className="border-t mt-12"
    >
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Sobre nosotros */}
          <div className="flex flex-col items-center md:items-start">
            <img
              src="/marca-fondo-blanco.png"
              alt="Camping Playa Niklitschek Logo"
              className="h-20 mb-4 object-contain"
            />
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Sobre Nosotros
            </h3>
            <p className="text-sm text-gray-600 text-center md:text-left">
              Bienvenido a nuestro camping familiar en las orillas del Lago Llanquihue.
              Disfruta de naturaleza, aventura y tranquilidad.
            </p>
          </div>

          {/* Enlaces útiles */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Enlaces Rápidos
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/"
                  style={{
                    color: colors.textSecondary,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.primary
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textSecondary
                  }}
                  className="text-sm transition-colors"
                >
                  Inicio
                </a>
              </li>
              <li>
                <a
                  href="/reservar"
                  style={{
                    color: colors.textSecondary,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.primary
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textSecondary
                  }}
                  className="text-sm transition-colors"
                >
                  Hacer una Reserva
                </a>
              </li>
              <li>
                <a
                  href="/#espacios"
                  style={{
                    color: colors.textSecondary,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.primary
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.textSecondary
                  }}
                  className="text-sm transition-colors"
                >
                  Nuestros Espacios
                </a>
              </li>
            </ul>
          </div>

          {/* Redes Sociales */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Síguenos
            </h3>
            <p className="text-sm text-gray-600 mb-4">Conecta con nosotros en redes sociales</p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com/playaniklitschek"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: colors.textSecondary,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.primary
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.textSecondary
                }}
                className="inline-flex items-center justify-center w-10 h-10 transition-colors duration-300"
                title="Síguenos en Facebook"
                aria-label="Facebook"
              >
                {facebookIcon}
              </a>
              <a
                href="https://youtube.com/c/foo"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: colors.textSecondary,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.primary
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.textSecondary
                }}
                className="inline-flex items-center justify-center w-10 h-10 transition-colors duration-300"
                title="Síguenos en YouTube"
                aria-label="YouTube"
              >
                {youtubeIcon}
              </a>
              <a
                href="https://instagram.com/playaniklitschekpv"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: colors.textSecondary,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.primary
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.textSecondary
                }}
                className="inline-flex items-center justify-center w-10 h-10 transition-colors duration-300"
                title="Síguenos en Instagram"
                aria-label="Instagram"
              >
                {instagramIcon}
              </a>
            </div>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-500 text-center md:text-left">
              &copy; 2025 Camping Playa Niklitschek. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a
                href="#"
                style={{
                  color: colors.textSecondary,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.primary
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.textSecondary
                }}
                className="text-xs transition-colors"
              >
                Privacidad
              </a>
              <a
                href="#"
                style={{
                  color: colors.textSecondary,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.primary
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.textSecondary
                }}
                className="text-xs transition-colors"
              >
                Términos
              </a>
              <a
                href="/contacto"
                style={{
                  color: colors.textSecondary,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.primary
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.textSecondary
                }}
                className="text-xs transition-colors"
              >
                Contacto
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
